import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { Row } from 'react-flexbox-grid';
import { FormattedMessage } from 'react-intl';
import { FontIcon, IconButton } from 'material-ui';
import DatePicker from 'react-datepicker';

import { changePeriod, initialize } from './actions';
import Loading from '../../components/Loading';
import PanelMessage from '../../components/panels/PanelMessage';
import EntriesTable from './EntriesTable';

const TimeOverview = ({
  setTimePeriod,
  initializing,
  start,
  end,
  error,
  hasError,
  initializeFailed,
  timeInitialize,
}) => {
  useEffect(() => {
    timeInitialize();
  }, []);

  if (initializing) return <Loading />;

  if (initializeFailed || hasError) {
    return (
      <PanelMessage
        message={<FormattedMessage id="time.initialize.error" values={{ error }} />}
        iconName="error"
        type="error"
      />
    );
  }

  const isPeriod = moment(end).format('DD/MM/YYYY') === moment(start).add(1, 'month').add(-1, 'day').format('DD/MM/YYYY');

  const isMonth = (
    moment(start).format('DD/MM/YYYY') === moment(start).startOf('month').format('DD/MM/YYYY')
  && moment(end).format('DD/MM/YYYY') === moment(end).endOf('month').format('DD/MM/YYYY')
  );

  const setLastPeriod = () => {
    if (isMonth) {
      setTimePeriod(moment(start).add(-1, 'month'), moment(end).add(-1, 'month').endOf('month'));
    } else if (isPeriod) {
      setTimePeriod(moment(start).add(-1, 'month'), moment(start).add(-1, 'day'));
    } else {
      const numberOfDays = moment(end).diff(start, 'days') + 1;
      setTimePeriod(moment(start).add(-numberOfDays, 'days'), moment(end).add(-numberOfDays, 'days'));
    }
  };

  const setNextPeriod = () => {
    if (isMonth) {
      setTimePeriod(moment(start).add(1, 'month'), moment(end).add(1, 'month').endOf('month'));
    } else if (isPeriod) {
      setTimePeriod(moment(start).add(1, 'month'), moment(start).add(2, 'month').add(-1, 'day'));
    } else {
      const numberOfDays = moment(end).diff(start, 'days') + 1;
      setTimePeriod(moment(start).add(numberOfDays, 'days'), moment(end).add(numberOfDays, 'days'));
    }
  };

  const setStartDate = (date) => {
    setTimePeriod(date, end);
  };

  const setEndDate = (date) => {
    setTimePeriod(start, date);
  };

  return (
    <React.Fragment>
      <Row middle="xs" center="xs">
        <div style={{ display: 'flex', alignItems: 'center', paddingTop: 16 }}>
          <IconButton onClick={setLastPeriod} style={{ marginRight: 12 }}>
            <FontIcon className="material-icons">arrow_back</FontIcon>
          </IconButton>
          <span style={{ fontSize: 18, fontWeight: 400 }}>
            <DatePicker
              selected={moment(start)}
              onChange={setStartDate}
              dateFormat="DD.MMM YYYY"
              selectsStart
              startDate={moment(start)}
              endDate={moment(end)}
            />
            {' - '}
            <DatePicker
              selected={moment(end)}
              onChange={setEndDate}
              dateFormat="DD.MMM YYYY"
              selectsEnd
              startDate={moment(start)}
              endDate={moment(end)}
              minDate={moment(start)}
            />
          </span>
          <IconButton onClick={setNextPeriod} style={{ marginLeft: 12 }}>
            <FontIcon className="material-icons">arrow_forward</FontIcon>
          </IconButton>
        </div>
      </Row>
      <EntriesTable />
    </React.Fragment>
  );
};

TimeOverview.propTypes = {
  timeInitialize: PropTypes.func.isRequired,
  setTimePeriod: PropTypes.func.isRequired,
  initializing: PropTypes.bool.isRequired,
  start: PropTypes.shape({}).isRequired,
  end: PropTypes.shape({}).isRequired,
  hasError: PropTypes.bool.isRequired,
  initializeFailed: PropTypes.bool.isRequired,
  error: PropTypes.string,
};

TimeOverview.defaultProps = {
  error: null,
};

export default connect(
  ({ timeReducer }) => ({ ...timeReducer }),
  dispatch => ({
    timeInitialize: () => dispatch(initialize()),
    setTimePeriod: (from, to) => dispatch(changePeriod(from, to)),
  }),
)(TimeOverview);



// WEBPACK FOOTER //
// ./src/sites/time/TimeOverview.js